import { Grid, Paper } from '@material-ui/core'
import { Fragment } from 'react'
import { AfterShowingStepProps } from '../ContractGeneratorStepper'
import ContractGeneratorForm from '../ContractGeneratorForm'

const ContractGeneratorSteps = ({
    currentStep,
    // apartment,
    classes,
    saveInstantRent,
    doStepBack,
    beforeLogin,
    isMobile
}: AfterShowingStepProps) => {
    return (
        <Fragment>
            <Grid item sm={12} md={12}>
                <Paper className={classes.formPaper}>
                    <ContractGeneratorForm
                        classes={classes}
                        saveInstantRentForm={saveInstantRent}
                        currentStep={currentStep}
                        doStepBack={doStepBack}
                        beforeLogin={beforeLogin}
                        isMobile={isMobile}
                    />
                </Paper>
            </Grid>
        </Fragment>
    )
}

export default ContractGeneratorSteps